import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { type ApiConfig } from '@pkgs/api/types';
import {
  getTrackingByGa4Id as generatedGetTrackingByGa4Id,
  type GetTrackingByGa4IdResult as GeneratedGetTrackingByGa4IdResult,
} from '@generated/search-bff/controllers/tracking-v2/tracking-v2';

/**
 * Returns all tracking ids based on a given google GA4 id using the `/api/v2/tracking/ga4/{ga4Id}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/tracking/getTrackingByGa4Id Search API Documentation}
 */
export function getTrackingByGa4Id(ga4Id: string, apiConfig: ApiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getTrackingByGa4Id');
  return generatedGetTrackingByGa4Id(ga4Id, _apiConfig);
}

export type GetTrackingByGa4IdResult = GeneratedGetTrackingByGa4IdResult;
